import React, { useState } from 'react';
import '../../styles/Features.css';
import { 
  Settings, 
  BarChart3, 
  Smartphone, 
  Factory
} from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import ImageModal from '../ImageModal';

interface Feature {
  icon: React.ReactNode;
  title: string;
  description: string;
  color: string;
}

const Features: React.FC = () => {
  const { t } = useLanguage();
  const [modalImage, setModalImage] = useState<{ src: string; alt: string } | null>(null);

  const openModal = (src: string, alt: string) => {
    setModalImage({ src, alt });
  };

  const closeModal = () => {
    setModalImage(null);
  };
  const features: Feature[] = [
    {
      icon: <Settings className="w-8 h-8" />,
      title: t('features.module1.title'),
      description: t('features.module1.description'),
      color: "from-blue-500 to-blue-600"
    },
    {
      icon: <BarChart3 className="w-8 h-8" />,
      title: t('features.module2.title'),
      description: t('features.module2.description'),
      color: "from-purple-500 to-purple-600"
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: t('features.module3.title'),
      description: t('features.module3.description'),
      color: "from-green-500 to-green-600"
    },
    {
      icon: <Factory className="w-8 h-8" />,
      title: t('features.module4.title'),
      description: t('features.module4.description'),
      color: "from-red-500 to-red-600"
    }
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        {/* Mozmina System Overview Image */}
        <div className="section-image-container">
          <img 
            src="/images/mozmina_system.png" 
            alt="Mozmina System Overview" 
            className="section-image clickable-image"
            onClick={() => openModal("/images/mozmina_system.png", "Mozmina System Overview")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                openModal("/images/mozmina_system.png", "Mozmina System Overview");
              }
            }}
          />
        </div>
        
        <div className="section-header">
          <h2>{t('features.title')}</h2>
          <p>
            {t('features.description')}
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              
              <h3>{feature.title}</h3>
              
              <p>{feature.description}</p>

              <div className="feature-gradient" style={{ background: `linear-gradient(135deg, ${feature.color})` }}></div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Image Modal */}
      <ImageModal
        isOpen={modalImage !== null}
        imageSrc={modalImage?.src || ''}
        imageAlt={modalImage?.alt || ''}
        onClose={closeModal}
      />
    </section>
  );
};

export default Features;